import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/services';
import { PermissionsList } from '@shared/common/permissionsList.enum';
import { environment } from '@envs/environment';

export const bIAccessGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  if (environment.isStandalonePortal) {
    return true;
  }

  const hasBIAccess = authService
    .currentUser()
    ?.permissionList.includes(PermissionsList['DispatcherDashboardBIView']);

  if (!hasBIAccess) {
    const { localDomain } = environment;
    const ACCESSDENIED_ROUTE = '/403';
    const url = localDomain + ACCESSDENIED_ROUTE;
    window.open(url, '_self');
    return false;
  }

  return true;
};
